import React from 'react';

const LoadingSquare = props => <div className="skeletonSquare" {...props} />;

export default LoadingSquare;
